module.exports = __webpack_public_path__ + "static/banner-84c6d71d1a288d4e48f3b5a81d6a54ad.jpg";